export enum VitalsInputErrorMsg {
    TEMPERATURE= "The Temperature range is from 98 - 106. Please enter a valid value.",
    PULSE= "The Pulse range is from 35 - 210. Please enter a valid value.",
    RESPIRATION= "The Respiration range is from 1 - 70. Please enter a valid value."
}
